import { BrowserRouter, Route, Routes } from "react-router-dom";
import Dispatchers from "./pages/subs/dispatcher";
import { WaterMark } from "@ant-design/pro-layout";
import { appKeyMap } from './constants/gdMppKey';
import Dashbord from "./pages/subs/dashbord";
import ServeTab from "./pages/subs/serveTab";
import Login from "./pages/login/login";
import Index from "./pages/index";
import { useEffect } from "react";
import "./App.scss";

function App() {

  useEffect(() => {
    window.forceWebGL = true;
    const randomNum = Math.floor(Math.random() * 4); 
    const appKey = appKeyMap[randomNum]
    const script = document.createElement("script");
    script.src = `https://webapi.amap.com/maps?v=2.0&key=${appKey.key}&plugin=AMap.Autocomplete`;
    document.body.appendChild(script);
    window._AMapSecurityConfig = { securityJsCode: appKey.securityCode };
  }, []);

  return (
    <WaterMark content="拖车侠">
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Index />}>
              <Route path="/dashbord" element={<Dashbord />} />
              <Route path="/history" element={<ServeTab />} />
              <Route path="/pricing" element={<ServeTab />} />
              <Route path="/subsidiary" element={<ServeTab />} />
              <Route path="/dispatchers" element={<Dispatchers />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </div>
    </WaterMark>
  );
}

export default App;
